module.exports = __webpack_public_path__ + "HappyCreditologo.18b92941.png";